export const CO_GET_HEAVEYCOLLI_LISTING = "CO_GET_HEAVEYCOLLI_LISTING"
export const CO_GET_HEAVEYCOLLI_LISTING_SUCCESS = "CO_GET_HEAVEYCOLLI_LISTING_SUCCESS"
export const CO_GET_HEAVEYCOLLI_LISTING_FAILED = "CO_GET_HEAVEYCOLLI_LISTING_FAILED"
